import { render, staticRenderFns } from "./default-layout.vue?vue&type=template&id=f34e8fae&scoped=true&"
import script from "./default-layout.ts?vue&type=script&lang=js&"
export * from "./default-layout.ts?vue&type=script&lang=js&"
import style0 from "./default-layout.vue?vue&type=style&index=0&id=f34e8fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34e8fae",
  null
  
)

export default component.exports